import type { TeamFilter } from "@dashboardApi/apis/teamsData/types";

import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import sharedConstants from "@lib/shared_constants";
import type { SHARED_CONSTANTS_TERRITORY_MANAGEMENT } from "@lib/shared_constants";

/**
 * Returned as a 4xx when save-path filter validation rejects a filter the team would have
 * persisted, so the form can show the server's reason rather than a generic failure.
 */
export type TeamEditInvalidFilterError = FetchUserEncodedError<
  SHARED_CONSTANTS_TERRITORY_MANAGEMENT["ERROR_CODES"]["INVALID_FILTER"]
>;

export const isTeamEditInvalidFilterError = (error: FetchRequestError): error is TeamEditInvalidFilterError => {
  return (
    error instanceof FetchUserEncodedError &&
    error.errorCode === sharedConstants.TERRITORY_MANAGEMENT.ERROR_CODES.INVALID_FILTER
  );
};

export interface TeamEditResult {
  info: string;
}

export interface PostAppsAppGroupIdTerritoryEditProps {
  appGroupId: string;
  id: string;
  name: string;
  /**
   * The reachable-audience filters to persist. Omitted when `filters_unchanged` is sent. A flat
   * array of leaf filters (the same shape persisted on `TeamDescriptor.filters`).
   */
  filters?: TeamFilter[];
  /**
   * When true, the backend preserves the team's existing filters rather than re-deserializing a
   * payload. Sent by the team settings form when the audience filters were never edited, to limit
   * blast radius if a filter serialization bug is introduced.
   */
  filters_unchanged?: boolean;
}
